/** Edge search Worker on the canonical host (`/s/q`, `/s/boot`). */
const APEX_SEARCH_ORIGIN = 'https://hizlicicek.com';

export function getSearchOrigin(): string {
  const raw = (process.env.NEXT_PUBLIC_SEARCH_ORIGIN || '').trim();
  if (raw) return raw.replace(/\/+$/, '');
  // Browser: same-origin `/s/*`. SSR: absolute apex so Next does not hit ALB.
  if (typeof window !== 'undefined') return '';
  return APEX_SEARCH_ORIGIN;
}
